import {
  RELATED_TRANSACTIONS_FAILURE,
  RELATED_TRANSACTIONS_REQUEST,
  RELATED_TRANSACTIONS_SUCCESS,
  RELATED_TRANSACTIONS_RESET,
} from '../actions/related_transactions'

export const fetchRelatedTransactions = (
  state = {
    isFetching: false,
    results: [],
    errorMessage: null,
    count: 0,
  },
  action
) => {
  switch (action.type) {
    case RELATED_TRANSACTIONS_REQUEST:
      return {
        ...state,
        results: [],
        isFetching: true,
        errorMessage: null,
      }
    case RELATED_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        results: action.response.results,
        count: action.response.count,
      }
    case RELATED_TRANSACTIONS_FAILURE:
      return {
        ...state,
        errors: null,
        results: [],
        isFetching: false,
        errorMessage: action.error,
      }
    case RELATED_TRANSACTIONS_RESET:
      return {
        ...state,
        errors: null,
        isFetching: false,
        results: [],
        errorMessage: null,
        count: 0,
      }
    default:
      return state
  }
}
